import type { StateCreator } from "zustand";
import type { ToolbarActionsSlice } from "../../interfaces/slicesInterfaces/toolbarActionsSlice";
 

export const createToolbarActionsSlice: StateCreator<
ToolbarActionsSlice,
  [],
  [],
  ToolbarActionsSlice
> = (set, get) => ({
  micStatus: "muted",
  showMicNotification: true,
  isVideoOn: false,
  isMicOn: false,
  setIsVideoOn: (value: boolean) => {
    set({ isVideoOn: value });
  },
  setIsMicOn: (value: boolean) => {
    set({ isMicOn: value });
  },
  setMicStatus: (status: "connected" | "muted") => {
    set({ micStatus: status });
  },
  setShowMicNotification: (show: boolean) => {
    set({ showMicNotification: show });
  },
  cycleNextMicStatus: () => {
    const { micStatus } = get();

    // Simple toggle between muted and connected (no disconnected state)
    return micStatus === "connected" ? "muted" : "connected";
  },
});
